import {
  MAINTENANCE_STATUS_LABELS,
  type MaintenanceStatus,
} from '@/modules/maintenance/types/maintenance';

const STATUS_CLASS: Record<MaintenanceStatus, string> = {
  scheduled: 'status-badge--reserved',
  in_progress: 'status-badge--in-use',
  completed: 'status-badge--available',
  cancelled: 'status-badge--inactive',
};

type MaintenanceStatusBadgeProps = {
  status: MaintenanceStatus;
};

export function MaintenanceStatusBadge({ status }: MaintenanceStatusBadgeProps) {
  return (
    <span className={`status-badge ${STATUS_CLASS[status]}`}>
      {MAINTENANCE_STATUS_LABELS[status]}
    </span>
  );
}
